import React from "react";
import { Grid } from "@mui/material";
import { Field } from "formik";
import Decimal from "../../../../form/controls/DecimalFormik";

const ExceedThresholdFields = ({ type, isExceedesThresholdRuleActive }) => (
  <>
    <Grid item xs={2}>
      <Field
        id={`${type}NumOfUnits`}
        name={`${type}NumOfUnits`}
        label="Number Of Units"
        type="text"
        component={Decimal}
        disabled={!isExceedesThresholdRuleActive}
        allowNegative={false}
      />
    </Grid>

    <Grid item xs={2}>
      <Field
        id={`${type}DiscountAmount`}
        name={`${type}DiscountAmount`}
        label="Discount Amount"
        type="text"
        component={Decimal}
        disabled={!isExceedesThresholdRuleActive}
        allowNegative={false}
      />
    </Grid>
    <Grid item xs={2}>
      <Field
        id={`${type}NetTotal`}
        name={`${type}NetTotal`}
        label="Net Total"
        type="text"
        component={Decimal}
        disabled={!isExceedesThresholdRuleActive}
        allowNegative={false}
      />
    </Grid>
    <Grid item xs={2}>
      <Field
        id={`${type}Surcharge1Amount`}
        name={`${type}Surcharge1Amount`}
        label="Surcharge 1 Amount"
        type="text"
        component={Decimal}
        disabled={!isExceedesThresholdRuleActive}
        allowNegative={false}
      />
    </Grid>
    <Grid item xs={2}>
      <Field
        id={`${type}Surcharge2Amount`}
        name={`${type}Surcharge2Amount`}
        label="Surcharge 2 Amount"
        type="text"
        component={Decimal}
        disabled={!isExceedesThresholdRuleActive}
        allowNegative={false}
      />
    </Grid>
    <Grid item xs={2}>
      <Field
        component={Decimal}
        id={`${type}Ctc`}
        name={`${type}Ctc`}
        label="Total Cost Client"
        type="text"
        disabled={!isExceedesThresholdRuleActive}
        allowNegative={false}
      />
    </Grid>
  </>
);

export default ExceedThresholdFields;
